import store from '../store'
export default {
  toast(msg, callback) {
    store.commit('system/setDialog', {
      message: msg,
      type: 'tips',
      callback: callback || null
    });
  },
  alert(msg, callback) {
    store.commit('system/setDialog', {
      message: msg,
      type: 'alert',
      callback: callback || null
    })
  },
  confirm(msg, callback) {
    store.commit('system/setDialog', {
      message: msg,
      type: 'confirm',
      callback: callback || null
    })
  },
}



// WEBPACK FOOTER //
// ./src/service/dialogService.js